<template>
  <div id="app">
    <div class="row" v-show="initialLoading">
      <div class="col-12">
        <p class="card-text text-center">
          Chargement... <i class="fas fa-spin fa-spinner"></i>
        </p>
      </div>
    </div>
    <div class="row" v-if="!initialLoading && !displayPlanning && !displayDomicile">
      <div class="col-12 text-center">
        <button id="main-osteo-button"
                class="btn btn-primary fixed-width-button gradient"
                :data-toggle="showModalNoBooking()?'modal':''"
                :data-target="showModalNoBooking()?'#bookingModal':''"
                v-on:click="onContactClicked()">
          <i class="fas fa-calendar"></i> Prendre rendez-vous avec Osteopratic
        </button>
      </div>

    </div>
    <div class="card shadow" v-if="displayPlanning">
      <div class="overlay" v-if="calendarLoading">
        <i class="fas fa-4x fa-spin fa-spinner"></i>
      </div>
      <div class="card-header">
        Choisissez un horaire, saisissez vos coordonnées puis réservez. Votre rendez vous
        est pris !
      </div>
      <div class="card-body row">
        <div class="col-md-6 text-center" style="overflow-y: scroll; max-height: 520px;">
          <div class="row">
            <div class="col-3 text-center">
              <button type="button" class="btn btn-primary"
                      v-show="currentDay.subtract(1, 'day').isAfter(minDay)"
                      v-on:click="onNavClicked(false)">
                <i class="fas fa-chevron-left"></i>
              </button>
            </div>
            <div class="col-6 text-center">
              <h2 class="header-date">{{ getCurrentDay() }}</h2>
            </div>
            <div class="col-3 text-center">
              <button type="button" class="btn btn-primary"
                      v-on:click="onNavClicked(true)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>


          </div>
          <div class="slot w-50 hvr-grow"
               v-if="getAvailableSlots().length > 0"
               v-bind:class="{'selected-slot': selectedEvent && selectedEvent.start === slot.start}"
               v-for="slot in getAvailableSlots()"
               v-on:click="onEventClicked(slot)">
          <span class="p-2">
            {{ formatHour(slot.start) }} - {{ formatHour(slot.end) }}
          </span>
          </div>
          <div v-if="getAvailableSlots().length === 0" class="w-100 text-center mt-2">
          <span class="mt-2 mb-2">
            Aucun créneau disponible
          </span>
          </div>
        </div>
        <div class="col-md-6">
          <h2 class="header-date">
            {{ getSelectedDateText() }}
          </h2>
          <contact-form :is-booking="true"
                        :osteoId="osteoId"
                        v-on:bookingCancel="onBookingCancel()"
                        v-on:bookingLoadingStart="onBookingLoadingStart()"
                        v-on:bookingLoadingEnd="onBookingLoadingEnd()"
                        v-on:bookingSuccess="onBookingSuccess()"
                        :selected-event="selectedEvent">
          </contact-form>
        </div>
      </div>


    </div>
    <div class="card shadow" v-if="displayDomicile">
      <div class="card-header">
        Saisissez vos coordonnées puis réservez. Vous serez recontacté rapidement!
      </div>
      <div class="card-body row">
        <div class="col-md-6 mt-2">
          <div class="alert alert-info" role="alert">
            <i class="fas fa-info-circle"></i> Ce praticien ne faisant que du domicile, veuillez renseigner vos
            coordonnées puis
            valider. Vous serez recontacté.
          </div>
        </div>
        <div class="col-md-6">
          <contact-form :is-booking="false"
                        v-on:fetchPlanning="fetchPlanning(true)">
          </contact-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import fr from 'dayjs/locale/fr';
import ContactForm from "./ContactForm";

const LOCALE = 'fr';
const TIMEZONE = 'Europe/Paris';
const DATE_MONTH_YEAR_FORMAT = 'dddd D MMMM';
const HOUR_FORMAT = 'HH:mm';

export default {
  name: 'app',
  components: {
    'contact-form': ContactForm
  },
  data() {
    return {
      fetchedRange: null,
      osteoId: null,
      hasPlanning: null,

      domicile: false,
      calendarLoading: false,
      initialLoading: true,
      selectedEvent: null,

      bookingLoading: false,
      displayPlanning: false,
      displayDomicile: false,

      currentDay: null,
      minDay: null,

      fetchedSlots: [],
    };
  },
  mounted() {
    dayjs.locale(LOCALE);
    dayjs.extend(utc);
    dayjs.extend(timezone);
    this.osteoId = $("#osteo-id").val();
    this.currentDay = dayjs().tz(TIMEZONE);
    this.minDay = dayjs().set('hour', 0);
    this.checkIfProspectHasPlanning();
    setInterval(
      () => {
        if (this.hasPlanning && !this.bookingLoading) {
          this.fetchPlanning(false);
        }
      }, 10000
    );
  },
  methods: {
    // Events
    onContactClicked() {
      console.log(this.hasPlanning);
      if (this.hasPlanning) {
        this.displayPlanning = true;
      } else if (this.domicile) {
        this.displayDomicile = true;
      } else {
        this.notifyPraticien();
      }
    },
    onEventClicked(slot) {
      this.selectedEvent = slot;
    },
    onNavClicked(next) {
      this.currentDay = next ? this.currentDay.add(1, 'day') : this.currentDay.subtract(1, 'day');
      if (this.currentDay.isBefore(this.fetchedRange.start) || this.currentDay.isAfter(this.fetchedRange.end)) {
        this.fetchPlanning(true);
      }
    },
    onBookingSuccess() {
      this.fetchPlanning(true);
      this.selectedEvent = null;
    },
    onBookingCancel() {
      this.selectedEvent = null;
    },
    onBookingLoadingStart() {
      this.bookingLoading = true;
    },
    onBookingLoadingEnd() {
      this.bookingLoading = false;
    },


    // Display
    showModalNoBooking() {
      return !this.domicile && !this.hasPlanning;
    },
    getSelectedDateText() {
      if (this.selectedEvent) {
        const start = this.selectedEvent.start;
        const end = this.selectedEvent.end;
        const eventDate = dayjs(start).tz(TIMEZONE).format(DATE_MONTH_YEAR_FORMAT);
        const startHour = dayjs(start).tz(TIMEZONE).format(HOUR_FORMAT);
        const endHour = dayjs(end).tz(TIMEZONE).format(HOUR_FORMAT);
        return `Le ${eventDate} de ${startHour} à ${endHour}`;
      }
      return 'Veuillez sélectionner un créneau disponible';

    },
    formatHour(isoDateString) {
      return dayjs(isoDateString).format(HOUR_FORMAT);
    },
    getAvailableSlots() {
      return this.fetchedSlots
        .filter(slot =>
          dayjs(slot.start).isAfter(this.currentDay.startOf('day')) &&
          dayjs(slot.end).isBefore(this.currentDay.endOf('day')));

    },
    getCurrentDay() {
      return this.currentDay.format(DATE_MONTH_YEAR_FORMAT);
    },

    // API
    checkIfProspectHasPlanning() {
      $.ajax({
        url: ajaxUrl,
        data: {
          action: 'osteo_single',
          id: this.osteoId,
          start: dayjs().startOf('day').toISOString(),
          end: dayjs().endOf('day').toISOString()
        },
        success: result => {
          console.log(result);
          if (result.code === 200) {
            $(".osteo-email").removeClass("link-disabled");

            if (result.payload.planningSet) {
              this.hasPlanning = true;
              this.fetchPlanning(true);
            } else {
              this.hasPlanning = false;
              this.domicile = true;
            }
          } else if (result.code === 404) {
            this.hasPlanning = false;
            $(".osteo-email").removeAttr("href");

          }
        },
        error: error => console.error(error),
        complete: () => this.initialLoading = false
      });
    },
    fetchPlanning(displayLoading) {
      let firstFetch = false;
      if (displayLoading) {
        this.calendarLoading = true;
      }

      //first fetch
      if (this.fetchedRange === null) {
        this.fetchedRange = {
          start: dayjs(),
          end: dayjs().add(1, 'month')
        };
        firstFetch = true;
      }

      // we're outside of range
      if (this.currentDay.toDate().getTime() > this.fetchedRange.end.toDate().getTime()) {
        this.fetchedRange.end = this.fetchedRange.end.add(1, 'month');
      }

      //we fetch
      $.ajax({
          url: ajaxUrl,
          data: {
            action: 'osteo_single',
            id: this.osteoId,
            start: this.fetchedRange.start.toISOString(),
            end: this.fetchedRange.end.toISOString()
          },
          success: result => {

            //we found the planning we can display it
            if (result.code === 200) {

              this.fetchedSlots = result.payload.appointments.map(
                appointment => ({
                  start: appointment.begAppointment,
                  end: appointment.endAppointment
                })
              ).sort((slot1, slot2) => dayjs(slot1.start).diff(dayjs(slot2.start)));

              //on the first first we navigate to the first day with slots.
              if (firstFetch && this.fetchedSlots.length > 0) {
                this.currentDay = dayjs(this.fetchedSlots[0].start);
              }

            } else if (result.code === 404) {
              this.hasPlanning = false;
            }
          },
          error: console.error,
          complete: () => {
            this.calendarLoading = false;
            if (this.initialLoading)
              this.initialLoading = false;
          }
        }
      );
    },
    notifyPraticien() {
      const data = {
        action: 'osteo_contact',
        email: $('#osteo-email').val(),
      };
      $.ajax({
        url: ajaxUrl,
        data: data,
        success: result => console.log(result)
      });

    },
  }
};
</script>

<style lang="scss">

.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
}

.hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}


.slot {
  background-color: #1BDCC4;
  color: #FFFFFF;
  margin: 5px 40px;
  padding: 15px 5px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}

.selected-slot {
  background-color: #3CA8EB;
}

.overlay {
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
}

.overlay i {
  position: absolute;
  top: 50%;
  left: 50%;
  color: white;
}

.fc-scrollgrid thead, .fc .fc-timegrid-slot-label-cushion {
  display: none;
}

.fc-timegrid-slot, .table-bordered, .table-bordered td {
  border: none !important;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b1b1b1;
}

.gradient {
  background: linear-gradient(135deg, rgb(0, 201, 255), rgb(146, 254, 157));
  border-width: 0 !important;
  color: rgb(23, 62, 43);
  box-shadow: 0px 15px 25px -4px rgba(30, 30, 60, 0.25);
}

.header-date {
  font-size: 20px !important;
}


</style>



// WEBPACK FOOTER //
// src/App.vue